<template>
  <div>
    <!-- input search -->
    <a-row class="mb-20 mt-20">
      <a-col :xs="{ span: 20, offset: 2 }" :lg="{ span: 12, offset: 6 }">
        <h6 class="text-center mb-20">Search for personal information</h6>
        <a-auto-complete class="global-search" size="large" style="width: 100%" placeholder="Input keyword here ..."
          :default-active-first-option="false" option-label-prop="title" @search="queryDataTy">
          <template slot="dataSource">
            <a-select-option v-for="(item, index) in dataSource" :key="'cards' + index" :title="item">
              {{ item }}
            </a-select-option>
          </template>
          <a-input-search allow-clear v-model="valText" @search="searchProfile"
            @compositionstart="isComposing = true" @compositionend="isComposing = false" />
        </a-auto-complete>
      </a-col>
    </a-row>

    <div v-if="viewPagination && valText !== ''" class="text-center">
      <a-pagination :current="current" :page-size="pageSize" :total="countObjData" :item-render="itemRender"
        @change="onChangePage" />
    </div>
    
    <!-- loading -->
    <a-spin v-if="loading" tip="Searching ...">
      <div class="spin-content"></div>
    </a-spin>
    <!-- card profile -->
    <a-row v-if="dataResult.length != 0" class="mb-20 mt-20" :gutter="[16, 16]">
      <a-col v-for="(profile, index) in dataResult" :key="'profile' + index" :xs="{ span: 24 }" :sm="{ span: 24 }"
        :md="{ span: 16 }" :lg="{ span: 8 }">
        <card-profile :profile="profile" />
      </a-col>
    </a-row>
    <!-- card direc contact -->
    <div v-if="showDirectCall" class="mt-20 mb-20">
      <carddirec :dataDirectContact="dataCardDirec" />
    </div>

    <a-row v-if="showDirectCall" :style="{ marginTop: '20px' }">
      <a-col :xs="{ span: 20, offset: 2 }" :lg="{ span: 12, offset: 6 }">
        <a-alert class="text-center" type="info" show-icon>
          <div slot="message">
            <p :style="{ fontSize: '10px' }" class="mt-0 mb-0 font-web font-weight-bold">หากพบข้อมูล &nbsp;&nbsp;<u
                class="ml-10 mr-10">"<strong>เบอร์โทรศัพท์สำนักงาน</strong>"</u>&nbsp;&nbsp;
              ไม่ถูกต้องโปรดแจ้งข้อมูลที่ถูกต้องมายัง email
              &nbsp;&nbsp;&nbsp;&nbsp;<strong><a :style="{ fontSize: '12px' }"
                  href="mailto:ic-inhouse@mahidol.edu">ic-inhouse@mahidol.edu</a></strong> </p>
          </div>
        </a-alert>
      </a-col>
    </a-row>

  </div>
</template>

<script>
import cardProfile from "./cardprofile.vue";
import carddirec from "./carddirec.vue";
import itemDirecCall from "./callList.js"
export default {
  components: {
    cardProfile,
    carddirec,
  },
  data() {
    return {
      // dataCardDirec: itemDirecCall.items,
      dataCardDirec: [],
      showDirectCall: true,
      RegExLanguage: new RegExp(/[\u0E01-\u0E4F]/),
      viewPagination: false,
      current: 1,
      pageSize: 9,
      offset: 0,
      countObjData: 0,
      loading: false,
      dataSource: [],
      dataResult: [],
      inputSearch: "",
      valText: "",
      isComposing: false,
      debounceTimer: null,
    };
  },
  watch: {
    valText(val) {
      if (val == "") {
        this.dataResult = [];
        this.dataSource = [];
        this.viewPagination = false;
        this.loading = false;
        this.inputSearch = "";
        this.current = 1;
        this.offset = 0;
        this.countObjData = 0;
      }
    },
  },
  mounted() {
    this.getCallDirect()
  },
  methods: {
    sortItem(val) {
      val.sort(function (a, b) {
        let nameA = a.textName.toUpperCase();
        let nameB = b.textName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a href="javascript:;">Previous</a>;
      } else if (type === "next") {
        return <a href="javascript:;">Next</a>;
      }
      return originalElement;
    },
    checkEmptry(val) {
      return !['', null, 'null', '    '].includes(val) ? val : ''
    },
    compareByName(a, b) {
      let nameA = a.textName.toUpperCase();
      let nameB = b.textName.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    },
    mapDirectContact(item) {
      const tel = this.checkEmptry(item.tel);
      let phoneA = '';
      let phoneB = '';

      if (tel) {
        const parts = tel.split('#');
        if (parts.length > 0) {
          phoneA = parts[0];
          phoneB = parts.length > 1 ? parts[1] : '';
        }
      }

      return {
        id: this.checkEmptry(item.id),
        priority: this.checkEmptry(item.priority),
        pathImg: '',
        textName: this.checkEmptry(item.name_en),
        textNameTh: this.checkEmptry(item.name_th),
        phoneA: phoneA,
        phoneB: phoneB,
        mailA: this.checkEmptry(item.email),
        mailB: '',
        location: this.checkEmptry(item.location),
        detail: '',
        social: {
          'facebook': this.checkEmptry(item.facebook),
          'Line': this.checkEmptry(item.line),
          'website': this.checkEmptry(item.website),
          'ig': this.checkEmptry(item.ig),
          'fax': this.checkEmptry(item.fax),
        }
      };
    },
    async getCallDirect() {

      try {
        const res = await this.$http.get(`/directory/other/`);
        if (res.status === 200) {
          this.dataCardDirec = res.data.map(this.mapDirectContact);
          this.dataCardDirec.sort(this.compareByName);
          this.showDirectCall = true
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.openNotification({
          title: `Error ${error.response.status}`,
          msg: `Connect API : /directory/other/`,
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
        this.showDirectCall = false
      }
    },
    async fetchAndMapSuggestions(value, isThai) {
      try {
        const res = await this.$http.get(`/directory/?search=${value}`);
        if (res.status === 200) {
          this.dataSource = res.data.map((item) => {
            if (isThai) {
              return `${item.detail_user.fullname_thai}`;
            } else {
              return `${item.detail_user.fullname_eng}`;
            }
          });
        } else {
          
          const err = new Error('API Error');
          err.res = res;
          throw err;
        }
      } catch (error) {
        this.dataSource = [];
        // Optional: Error handling logic here
      }
    },
    async queryDataTy(value) {
      // Skip search during IME composition (Thai input)
      if (this.isComposing) return;
      // Debounce to avoid excessive API calls
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(async () => {
        this.dataSource = [];
        if (value.length >= 2 && !['', null, ' ', 'null'].includes(value)) {
          await this.fetchAndMapSuggestions(value, this.RegExLanguage.test(value));
        } else {
          if ([''].includes(value)) { this.getCallDirect(); }
        }
      }, 300);
    },
    async searchProfile(value) {
      this.loading = true;
      this.dataResult = [];
      if (!['', null, ' ', 'null'].includes(value)) {
        this.inputSearch = value;
        try {
          let newText = this.inputSearch.replaceAll(
            /^Assoc.Prof\.|^Asst.Prof\.|^Assoc. Prof. Dr\.|^Asst. Prof. Dr\.|^Asst\.|^Assoc\.|^Mr\.|^Ms\.|^Mrs\.|^Prof\.|^Dr\.|^รศ. พญ\.|^ศ. พญ\.|^รศ. ดร\.|^ผศ. ดร\.|^ผศ\.|^Professor\.|^ดร\.|^พญ\.|^นาย|^รศ\.|^น\.ส\.|^นาง\.*/g,
            ""
          );
          const res = await this.$http.get(
            `/directory/?search=${newText}&limit=${this.pageSize}&offset=${this.offset}`
          );
          if (res.status === 200) {
            this.dataResult = res.data.results.map((item) => {
              return {
                email: item.email,
                fulldepartment_eng: item.detail_user.fulldepartment_eng,
                fulldepartment_thai: item.detail_user.fulldepartment_thai,
                fullname_eng: item.detail_user.fullname_eng,
                fullname_thai: item.detail_user.fullname_thai,
                fullposition_eng: item.detail_user.fullposition_eng,
                fullposition_thai: item.detail_user.fullposition_thai,
                department_detail_thai: item.department_detail.name_thai,
                department_detail_eng: item.department_detail.name_eng,
                urlPic: item.img,
                telephone: item.telephone,
                updated_at: item.updated_at,
                staffId: item.code,
                working_status: item.working_status.wfh_contact,
              };
            });
            this.countObjData = res.data.count;
            this.offset = 0;
            this.showDirectCall = false
            this.viewPagination = true;
            this.loading = false;
          } else {
            const error = new Error('Request Failed');
            error.res = res;
            error.response = res;
            throw error;
          }
        } catch (error) {
          this.viewPagination = false;
          this.dataResult = [];
          this.countObjData = 0;
          this.inputSearch = "";
          this.loading = false;
          this.openNotification({
            title: `Error ${error.response.status}`,
            msg: `Connect API : /directory/?search Problemm !!!`,
            backgroundColor: "#ff1919",
            color: "#ffffff",
          });
        }
      } else {
        this.dataResult = [];
        this.viewPagination = false;
        this.dataResult = [];
        this.countObjData = 0;
        this.inputSearch = "";
        this.loading = false;
        this.showDirectCall = true
      }
    },
    openNotification(objNoti) {
      this.$notification.open({
        style: {
          backgroundColor: objNoti.backgroundColor,
          color: objNoti.color,
        },
        message: function (h) {
          return h("div", [h("strong", { class: "" }, objNoti.title)]);
        },
        description: objNoti.msg,
      });
    },
    onChangePage(current) {
      this.current = current;
      this.offset = Number.parseInt(current - 1) * Number.parseInt(this.pageSize);
      this.searchProfile(this.inputSearch);
    },
  },
};
</script>

<style scoped>
.spin-content {
  /* border: 1px solid #f0f7fc; */
  /* background-color: #999b9b; */
  padding: 30px;
}</style>